import { requestTool } from "../tools";



const getLayerStructures = () => requestTool.
    getRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/DynamicCrud/GetLayerStructure");

const getFreeSpaceArea = (data) => requestTool.
    postRequest(process.env.REACT_APP_DYNAMICTABLE_API_URL + "/FreeSpace/GetFreeSpaceArea",data);

export const freeSpaceAreaService = {

    getLayerStructures,
    getFreeSpaceArea
};

export default freeSpaceAreaService;